import { render, staticRenderFns } from "./DocumentAttachment.vue?vue&type=template&id=6d34a3ee&scoped=true"
import script from "./DocumentAttachment.vue?vue&type=script&lang=js"
export * from "./DocumentAttachment.vue?vue&type=script&lang=js"
import style0 from "./DocumentAttachment.vue?vue&type=style&index=0&id=6d34a3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d34a3ee",
  null
  
)

export default component.exports